__turbopack_context__.v({
  "emptyStateButtonWrapper": "_3kXVVa_emptyStateButtonWrapper",
  "emptyStateHeader": "_3kXVVa_emptyStateHeader",
  "emptyStateWrapper": "_3kXVVa_emptyStateWrapper",
  "header": "_3kXVVa_header",
  "loaderWrapper": "_3kXVVa_loaderWrapper",
  "sortingInputWrapper": "_3kXVVa_sortingInputWrapper",
  "sortingLabel": "_3kXVVa_sortingLabel",
  "title": "_3kXVVa_title",
  "wrapper": "_3kXVVa_wrapper",
});
